import { render, staticRenderFns } from "./BusinessTransactionDetail.vue?vue&type=template&id=60d0a74d"
import script from "./BusinessTransactionDetail.vue?vue&type=script&lang=js"
export * from "./BusinessTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports